/**
 * Utility functions for handling contact tagging
 */

import { message } from "antd";
import { api } from "../../../api";
import { buildUIFilters } from "./filterUtils";

/**
 * Create tagging handlers
 */
export const createTaggingHandlers = (
  setTaggingFilterGroups,
  setTaggingContactCount,
  setShowTagPopup,
  setIsTagging,
  customer,
  refetch,
  setTaggingSegmentId,
) => {
  const handleAddTag = (filterGroups, contactCount, segmentId = null) => {
    if (segmentId) {
      // Locked segments have no re-evaluatable `filters` - tag the exact
      // snapshotted contact list via segmentId instead (see
      // tagStaticSegmentContacts.js).
      setTaggingSegmentId(segmentId);
      setTaggingFilterGroups(null);
    } else {
      // Transform the raw filter groups (with 'ors') to API format (with 'OR')
      const transformedFilters = buildUIFilters(filterGroups);
      setTaggingSegmentId(null);
      setTaggingFilterGroups(transformedFilters);
    }
    setTaggingContactCount(contactCount);
    setShowTagPopup(true);
  };

  const handleTagContacts = async (
    selectedTags,
    taggingFilterGroups,
    taggingContactCount,
    taggingSegmentId,
  ) => {
    if (selectedTags.length === 0) return;

    const tagIds = selectedTags.map((tag) => tag.id);

    // Show immediate feedback to user
    message.success(
      `Tags are being added to ${taggingContactCount} contact${taggingContactCount !== 1 ? "s" : ""} in the background`,
    );
    setShowTagPopup(false);
    setIsTagging(false);

    // Call the action in the background without waiting for response
    try {
      const request = taggingSegmentId
        ? api.tagStaticSegmentContacts({
            segmentId: taggingSegmentId,
            tagIds,
            customerId: customer.id,
          })
        : api.tagFilteredContacts({
            tagIds,
            apiFilters: taggingFilterGroups,
            customerId: customer.id,
          });

      // Don't await - let it run in background
      request
        .then((result) => {
          console.log("Tagging result:", result);
          // Optionally refresh data after completion
          refetch();
        })
        .catch((error) => {
          console.error("Error tagging contacts:", error);
          // Could show a subtle error message here if needed
        });
    } catch (error) {
      console.error("Error calling tagging action:", error);
    }
  };

  const handleCloseTagPopup = () => {
    setShowTagPopup(false);
    setTaggingContactCount(0);
    setTaggingFilterGroups([]);
    setTaggingSegmentId(null);
  };

  return {
    handleAddTag,
    handleTagContacts,
    handleCloseTagPopup,
  };
};
